/* eslint-disable */

/*
  This code was written by mighty canvas gods who have since perished. 
  Change at your own risk
*/

const docWidth = (el) => (el ? el.offsetWidth : document.documentElement.clientWidth);
const docHeight = (el) => (el ? el.offsetHeight : document.documentElement.clientHeight);

const projectPoints = (points3, width, height) => {
  const points2 = [];
  for (let index = points3.length - 1; index > -1; --index) {
    const p = points3[index];
    const x = p.x + width * 0.5;
    const y = p.y + height * 0.5;
    points2[index] = new Point2(x, y);
  }
  return points2;
};

const normalize = (fromMax, fromMin) => (toMax, toMin) => (val) => (toMax - toMin) / (fromMax - fromMin) * (val - fromMin) + toMin;

const elasticInOut = (k) => {
  if (k === 0) {
    return 0;
  }
  if (k === 1) {
    return 1;
  }
  k *= 2;
  if (k < 1) {
    return -0.5 * 2 ** (10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
  }
  return 0.5 * 2 ** (-10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
};

const Point2 = function (x, y) {
  this.x = x;
  this.y = y;
};
const Point3 = function (x, y, z) {
  this.x = x;
  this.y = y;
  this.z = z;
};
const Cube = function (x, y, z, size, offset, inset) {
  size *= 0.5;
  this.x = x;
  this.y = y;
  this.z = z;
  this.size = size;
  this.vertices = [
    new Point3(x - size, y - size, z - size), // 0
    new Point3(x + size, y - size, z - size), // 1
    new Point3(x + size, y + size, z - size), // 2
    new Point3(x - size, y + size, z - size), // 3
    new Point3(x - size, y - size, z + size), // 4
    new Point3(x + size, y - size, z + size), // 5
    new Point3(x + size, y + size, z + size), // 6
    new Point3(x - size, y + size, z + size), // 7
  ];
  this.faces = [{
    points: [0, 1, 2, 3],
    color: '#c9ddff',
    shipbobPoints: [4, 5, 6, 7],
  }, // Purple '#5300ef'
  {
    points: [0, 4, 5, 1],
    color: '#a1c4fc',
    shipbobPoints: [0, 1, 2, 3, 4],
  }, // Green  '#15ff00'
  {
    points: [0, 3, 7, 4],
    color: '#82b1ff',
    shipbobPoints: [7, 8, 9],
  }, // Yellow '#e8bd00'
  {
    points: [1, 5, 6, 2],
    color: '#c9ddff',
    shipbobPoints: [14, 15, 16, 17],
  }, // Blue   '#09285b'
  {
    points: [3, 2, 6, 7],
    color: '#a1c4fc',
    shipbobPoints: [10, 11, 12, 13, 14],
  }, // Red    '#e8003d'
  {
    points: [4, 7, 6, 5],
    color: '#82b1ff',
    shipbobPoints: [17, 18, 19],
  }, // Pink   '#ff4ced'
  ];
  const OFFSET = offset || 100;
  const INSET = inset || 30;
  const INSET2 = inset + 10 || 40;
  this.shipbobLogoPoints = [
    new Point3(x + size - INSET, y - size, z - size + OFFSET), // 1
    new Point3(x + size - INSET, y - size, z + size - INSET), // 5
    new Point3(x - size + INSET, y - size, z + size - INSET), // 4
    new Point3(x - size + INSET, y - size, z - size + INSET), // 0
    new Point3(x + size - INSET, y - size, z - size + INSET), // 1
    new Point3(x + size - INSET, y - size, z - size), // 1
    new Point3(x + size - INSET, y + size - INSET2, z - size), // 2
    new Point3(x - size, y + size - INSET2, z - size), // 3
    new Point3(x - size, y + size - INSET2, z + size - INSET), // 7
    new Point3(x - size, y - size + OFFSET, z + size - INSET), // 4

    new Point3(x + size - OFFSET, y + size, z - size + INSET), // 2
    new Point3(x - size + INSET, y + size, z - size + INSET), // 3
    new Point3(x - size + INSET, y + size, z + size - INSET), // 7
    new Point3(x + size - INSET, y + size, z + size - INSET), // 6
    new Point3(x + size - INSET, y + size, z - size + INSET), // 2
    new Point3(x + size, y + size, z - size + INSET), // 2
    new Point3(x + size, y - size + INSET2, z - size + INSET), // 1
    new Point3(x + size, y - size + INSET2, z + size), // 5
    new Point3(x - size + INSET, y - size + INSET2, z + size), // 4
    new Point3(x - size + INSET, y + size - OFFSET, z + size), // 7

  ];
};
Cube.prototype = {
  drawShipbob(shipbobPoints) {
    if (shipbobPoints) {
      const shipbobVertices = projectPoints(cube.shipbobLogoPoints, width, height);
      context.lineWidth = 5;
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.strokeStyle = '#3f89ff';
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.beginPath();
      context.lineWidth = 30;
      context.moveTo(shipbobVertices[shipbobPoints[0]].x, shipbobVertices[shipbobPoints[0]].y);
      for (let logoIndex = 1; logoIndex < shipbobPoints.length; logoIndex++) {
        context.lineTo(shipbobVertices[shipbobPoints[logoIndex]].x, shipbobVertices[shipbobPoints[logoIndex]].y);
      }
      context.stroke();
    }
  },
  draw(shouldDrawShipBobLogo = false) {
    const vertices = projectPoints(cube.vertices, width, height);

    for (let index = cube.faces.length - 1; index > -1; --index) {
      const face = cube.faces[index];
      const facePoints = face.points;
      const faceColor = face.color;
      const p1 = cube.vertices[facePoints[0]];
      const p2 = cube.vertices[facePoints[1]];
      const p3 = cube.vertices[facePoints[2]];
      const v1 = new Point3(p2.x - p1.x, p2.y - p1.y, p2.z - p1.z);
      const v2 = new Point3(p3.x - p1.x, p3.y - p1.y, p3.z - p1.z);
      const n = new Point3(v1.y * v2.z - v1.z * v2.y, v1.z * v2.x - v1.x * v2.z, v1.x * v2.y - v1.y * v2.x);

      const normal = -p1.x * n.x + -p1.y * n.y + -p1.z * n.z;
      const ISOOFFSET = 4000000; // when projecting to iso the cube is still rendering when in real life you wouldnt see it. this seems to be the magic number...
      if (normal - ISOOFFSET <= 0) {
        context.strokeStyle = '#ffffff';
        context.lineWidth = 5;
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.fillStyle = faceColor;
        context.beginPath();
        context.moveTo(vertices[facePoints[0]].x, vertices[facePoints[0]].y);
        context.lineTo(vertices[facePoints[1]].x, vertices[facePoints[1]].y);
        context.lineTo(vertices[facePoints[2]].x, vertices[facePoints[2]].y);
        context.lineTo(vertices[facePoints[3]].x, vertices[facePoints[3]].y);
        context.closePath();
        context.fill();
        context.stroke();
        if (shouldDrawShipBobLogo) this.drawShipbob(face.shipbobPoints);
      }
    }
  },
  rotX(degree) {
    const radian = degree * Math.PI / 180;
    const cosine = Math.cos(radian);
    const sine = Math.sin(radian);
    for (let index = this.vertices.length - 1; index > -1; --index) {
      const p = this.vertices[index];
      const y = (p.y - this.y) * cosine - (p.z - this.z) * sine;
      const z = (p.y - this.y) * sine + (p.z - this.z) * cosine;
      p.y = y + this.y;
      p.z = z + this.z;
    }
    for (let index = this.shipbobLogoPoints.length - 1; index > -1; --index) {
      const p = this.shipbobLogoPoints[index];
      const y = (p.y - this.y) * cosine - (p.z - this.z) * sine;
      const z = (p.y - this.y) * sine + (p.z - this.z) * cosine;
      p.y = y + this.y;
      p.z = z + this.z;
    }
  },
  rotY(degree) {
    const radian = degree * Math.PI / 180;
    const cosine = Math.cos(radian);
    const sine = Math.sin(radian);
    for (let index = this.vertices.length - 1; index > -1; --index) {
      const p = this.vertices[index];
      const x = (p.z - this.z) * sine + (p.x - this.x) * cosine;
      const z = (p.z - this.z) * cosine - (p.x - this.x) * sine;
      p.x = x + this.x;
      p.z = z + this.z;
    }
    for (let index = this.shipbobLogoPoints.length - 1; index > -1; --index) {
      const p = this.shipbobLogoPoints[index];
      const x = (p.z - this.z) * sine + (p.x - this.x) * cosine;
      const z = (p.z - this.z) * cosine - (p.x - this.x) * sine;
      p.x = x + this.x;
      p.z = z + this.z;
    }
  },
};

// calc waypoints traveling along vertices
function calcWaypoints(vertices, divisions) {
  const waypoints = [];
  for (let i = 1; i < vertices.length; i++) {
    const pt0 = vertices[i - 1];
    const pt1 = vertices[i];
    const dx = pt1.x - pt0.x;
    const dy = pt1.y - pt0.y;
    for (let j = 0; j < divisions; j++) {
      const x = pt0.x + dx * j / divisions;
      const y = pt0.y + dy * j / divisions;
      waypoints.push(new Point2(x, y));
    }
  }
  return (waypoints);
}

const flipCube = () => {
  const val = COUNTER += SIGN;
  const n = normalize(0, UPPER)(0, 1)(val);
  const e = elasticInOut(n);
  cube.rotX(e * 10);
  if (COUNTER >= UPPER) {
    SIGN *= -1;
  } else if (COUNTER <= 0) {
    SIGN *= -1;
  }
};

const drawLoopMain = () => {
  animationFrameId = window.requestAnimationFrame(drawLoop);
  height = docHeight(el);
  width = docWidth(el);
  context.canvas.height = height;
  context.canvas.width = width;
  context.fillStyle = 'rgba(255, 255, 255, 0)';
  context.fillRect(0, 0, width, height);
  context.strokeStyle = '#ffffff';
  cube.draw(true);

  flipCube();
};

const drawLoop = () => {
  if (t < wayPoints.length / 2 - waypointDivisions) {
    height = docHeight(el);
    width = docWidth(el);
    // draw a line segment from the last waypoint
    // to the current waypoint
    context.lineWidth = 5;
    context.lineCap = 'round';
    context.lineJoin = 'round';
    context.strokeStyle = '#3f89ff';
    context.lineCap = 'round';
    context.lineJoin = 'round';
    context.beginPath();
    context.lineWidth = 30;
    context.moveTo(wayPoints[t - 1].x, wayPoints[t - 1].y);
    context.lineTo(wayPoints[t].x, wayPoints[t].y);
    context.stroke();
    // increment "t" to get the next waypoint
    animationFrameId = window.requestAnimationFrame(drawLoop);
    t++;
  } else {
    drawLoopMain();
  }
};

const drawCube = () => {
  height = docHeight(el);
  width = docWidth(el);
  context.canvas.height = height;
  context.canvas.width = width;
  context.fillStyle = 'rgba(255, 255, 255, 0)';
  context.fillRect(0, 0, width, height);
  context.strokeStyle = '#ffffff';
  cube.draw();
};

const resetAnimation = () => {
  height = undefined;
  width = undefined;
  cube = undefined;
  t = 1;
  COUNTER = 0;
  SIGN = 2;
  UPPER = 180;
  wayPoints = undefined;
  context = undefined;
  waypointDivisions = 7;
  animationFrameId = undefined;
  el = undefined;
};

let height;
let width;
let cube;
let t;
let COUNTER;
let SIGN;
let UPPER;
let wayPoints;
let context;
let waypointDivisions;
let animationFrameId;
let el;

export const SplashRenderer = {
  DrawSplash: (_context, _el) => {
    resetAnimation();
    context = _context;
    cube = new Cube(0, 0, 500, 200);
    el = _el;
    height = docHeight(el);
    width = docWidth(el);

    context.canvas.height = height;
    context.canvas.width = width;

    cube.rotY(-45);
    cube.rotX(45);

    wayPoints = calcWaypoints(projectPoints(cube.shipbobLogoPoints, docWidth(el), docHeight(el)), waypointDivisions);

    drawCube();
    drawLoop();
  },
  DeleteSplash: () => {
    window.cancelAnimationFrame(animationFrameId);
    resetAnimation();
  },
};
